import { toast, ToastOptions } from "react-toastify"
import { DownLoadProcessCard } from "./DownLoadProcessCard"
import { DownloadQueueItem } from "./downloadQueue"

const toastMap = new Map<string, number>()

export const showToastProgress = (
  id: string,
  queues: DownloadQueueItem[],
  callBack: (type: "delete", downloadId) => Promise<void>,
  progress?: number,
  downloadId?: string
) => {
  const config: ToastOptions = {
    autoClose: false,
    closeOnClick: false,
    draggable: false,
    closeButton: false,
    className: "toast-download-progress",
  }
  const message = (
    <DownLoadProcessCard
      queues={queues}
      progress={progress}
      downloadId={downloadId}
      callBack={callBack}
    />
  )
  if (queues.length === 0) {
    toast.dismiss(toastMap.get(id)!)
    toastMap.delete(id)
    return
  }
  if (toastMap.has(id)) {
    toast.update(toastMap.get(id)!, {
      render: message,
      ...config,
    })
  } else {
    const toastId = toast(message, config)
    toastMap.set(id, toastId as number)
  }
}

export const clearToastProgress = (id: string) => {
  if (toastMap.has(id)) {
    toast.dismiss(toastMap.get(id)!)
    toastMap.delete(id)
  }
}
